<template>
  <dialogModule width="500px" top="15" :title="$t('payment.invoiceTitle')" v-if="invoiceVisible" :closeOnPressEscape="false" :dialogVisible="invoiceVisible" @close="close">
    <section slot="content" class="content">
      <div class="form-radio">
        <el-radio-group v-model="formData.buyerType" @input="changeType">
          <el-radio label="1" border>{{$t('payment.personalType')}}</el-radio>
          <el-radio label="2" border>{{$t('payment.enterpriseType')}}</el-radio>
        </el-radio-group>
      </div>
      <template v-if="formData.buyerType === '1'">
        <div class="form-item">
          <div><span>*</span>{{$t('payment.personalName')}}</div>
          <el-input size="small" :placeholder="$t('payment.inputPrompt')" v-model="formData.buyerLegalName"></el-input>
        </div>
        <div class="form-item">
          <div>{{$t('payment.idCardNo')}}</div>
          <el-input size="small" :placeholder="$t('payment.inputPrompt')" v-model="formData.buyerCard"></el-input>
        </div>
      </template>
      <template v-else>
        <div class="form-item">
          <div><span>*</span>{{$t('payment.enterpriseName')}}</div>
          <el-input size="small" :placeholder="$t('payment.inputPrompt')" v-model="formData.buyerLegalName"></el-input>
        </div>
        <div class="form-item">
          <div><span>*</span>{{$t('payment.taxCode')}}</div>
          <el-input size="small" :placeholder="$t('payment.inputPrompt')" v-model="formData.buyerTaxCode"></el-input>
        </div>
      </template>
      <div class="form-item">
        <div>{{$t('payment.address')}}</div>
        <el-input size="small" :placeholder="$t('payment.inputPrompt')" v-model="formData.buyerAddress"></el-input>
      </div>
      <div class="form-item">
        <div>{{$t('payment.emailAddress')}}</div>
        <el-input size="small" :placeholder="$t('payment.inputPrompt')" v-model="formData.buyerEmail"></el-input>
      </div>
      <el-button class="form-btn" type="primary" :loading="submitLoading" @click="submit">{{$t('payment.confirmBtn')}}</el-button>
    </section>
  </dialogModule>
</template>
<script>
import dialogModule from "@/components/dialogModule.vue"
import {newOrderCreateTaxInvoice} from "@/libs/http/modules/posOrder"
export default {
  props: {
    invoiceObj: {
      type: Object,
      default: () => null
    }
  },
  components: {
    dialogModule
  },
  data(){
    return{
      invoiceVisible: true,
      submitLoading: false,
      formData: {
        buyerType: '1',
        buyerCard: '',
        buyerEmail: '',
        buyerTaxCode: '',
        buyerAddress: '',
        buyerLegalName: ''
      }
    }
  },
  methods: {
    close(){
      this.invoiceVisible = false
      this.$emit('close')
    },
    changeType(){
      this.formData.buyerCard = ''
      this.formData.buyerEmail = ''
      this.formData.buyerTaxCode = ''
      this.formData.buyerAddress = ''
      this.formData.buyerLegalName = ''
    },
    submit(){
      let reqData = {
        orderId: this.invoiceObj.id,
        buyerType: this.formData.buyerType
      }
      if(this.formData.buyerType === '1'){
        if(!this.formData.buyerLegalName) return this.$message({ type: 'error', message: this.$t('payment.nameRequiredPrompt'), duration: 2000, showClose: true })
        reqData['buyerLegalName'] = this.formData.buyerLegalName
        if(this.formData.buyerCard){
          reqData['buyerCard'] = this.formData.buyerCard
        }
      }else{
        if(!this.formData.buyerLegalName) return this.$message({ type: 'error', message: this.$t('payment.enterpriseNameRequiredPrompt'), duration: 2000, showClose: true })
        if(!this.formData.buyerTaxCode) return this.$message({ type: 'error', message: this.$t('payment.taxCodeRequiredPrompt'), duration: 2000, showClose: true })
        reqData['buyerTaxCode'] = this.formData.buyerTaxCode
        reqData['buyerLegalName'] = this.formData.buyerLegalName
      }
      if(this.formData.buyerAddress){
        reqData['buyerAddress'] = this.formData.buyerAddress
      }
      if(this.formData.buyerEmail){
        const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        if(!emailReg.test(this.formData.buyerEmail)){
          return this.$message({ type: 'error', message: this.$t('payment.emailInputValidFormat'), duration: 2000, showClose: true })
        }
        reqData['buyerEmail'] = this.formData.buyerEmail
      }
      this.submitLoading = true
      newOrderCreateTaxInvoice(reqData).then(res=>{
        this.close()
        this.$emit('print')
        this.submitLoading = false
      }).catch(error=>{
        this.submitLoading = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
.content{
  margin: 20px;
  padding-bottom: 20px;
  .form-radio{
    margin-bottom: 20px;
  }
  .form-item{
    margin-bottom: 20px;
    div{
      margin-bottom: 4px;
      span{
        color: red;
        margin-right: 2px;
      }
    }
  }
  .form-btn{
    margin: auto;
    width: 200px;
    display: block;
    font-size: 16px;
  }
}
</style>